import { NextImageWithLoader } from '@/components/NextImageWithLoader';
import { cleanObject } from '@/lib/util';
import { theme } from '@/theme';

import type { CardProps } from '../../types';

import * as S from './IconType.styles';

export const IconType = (_props: CardProps) => {
  const props: CardProps = {
    contentAlignment: 'center',
    textAlignment: 'center',
    type: 'default',
    urlType: 'button',
    visibleInDesktop: _props.visibleInDesktop,
    visibleInMobile: _props.visibleInMobile,
    ...cleanObject(_props),
  };
  const backgroundColor = {
    ...props?.backgroundColor,
    value: props.backgroundColor?.value ?? theme.colors.white,
  };
  const headingTextColor = theme.colors.default;
  const processedProps: CardProps = {
    ...props,
    backgroundColor,
    headingTextColor,
    visibleInDesktop: _props.visibleInDesktop,
    visibleInMobile: _props.visibleInMobile,
  };
  return (
    <S.Container
      $backgroundColor={backgroundColor.value}
      $parentType={props.cardGroupType}
      $visibleInDesktop={_props.visibleInDesktop}
      $visibleInMobile={_props.visibleInMobile}
      data-test-id='IconTypeContainer'
    >
      <S.ImageWrapper
        data-test-id='IconTypeImageWrapper'
        $height={props.media?.image?.height ?? 96}
      >
        <NextImageWithLoader
          alt={props.media?.alt ?? props.media?.internalName ?? 'Icon'}
          data-test-id='IconTypeNextImage'
          height={props.media?.image?.height ?? 96}
          src={(props.media?.image?.url as string) ?? ''}
          width={props.media?.image?.width ?? 96}
        />
      </S.ImageWrapper>
      <S.Content {...processedProps} data-test-id='IconTypeTextType' />
    </S.Container>
  );
};
